var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{class:_vm.JobLevelRadio.classObject,attrs:{"type":"link","size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.handleStaffList(_vm.level)}}},[_vm._v("\n  "+_vm._s(_vm.JobLevelRadio.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }